import { Button } from "react-bootstrap";
import { scrollToTop } from "../../lib/PageUtils";
import styles from './Reset.module.css';

type Props = {
    text?: string;
    onClick: () => void;
    disabled?: boolean;
}

export default function Reset({
    text = 'Reset',
    onClick = () => {},
    disabled = false,
}: Props) {
    
    const handleClick = () => {
        scrollToTop();
        onClick();
    }

    return (
        <Button className={styles.reset}
            onClick={() => handleClick()} 
            disabled={disabled}>{text}
        </Button>
    );
}